import IEvent from "../types/event.type";
import moment from "moment";
import {Config} from "../cfg/Config";

class DateTimeUtil {
    getMonth(month: number, year: number) {
        if (month == 0) {
            return 12;
        }
        return month;
    }

    getYear(month: number, year: number) {
        if (month == 0) {
            return year - 1;
        }
        return year;
    }

    isWeekend(date: Date, events: IEvent[]): boolean {
        if (date.getDay() == 0) //sunday
            return true;
        if (date.getDay() != 6) //not saturday: from monday to friday
            return false;
        events?.map(event => {
            const eDate = new Date(event.start_str!);
            if (event.type == "day_off" && event.is_day_off == 0 && date.getFullYear() == eDate.getFullYear() && date.getMonth() == eDate.getMonth() && date.getDate() == eDate.getDate()) {
                return false; // replace working day
            }
        });
        if (date >= Config.saturdayOff)
            return true;
        let weekNumber = Number.parseInt(moment(date).format("w"));
        if (date.getFullYear() == 2023)
            weekNumber += 1;
        return weekNumber % 2 == 0;
    }
}

export default new DateTimeUtil();